module.exports = __webpack_public_path__ + "bd5bbe6317d08e70256246356edfc12e.MP3";